/* ============================================
   Senchado 2.0 — Product Hero
   出典: prototype/hero-mockup.html L4382-4962
   ※ 商品データは window.SENCHADO_HERO_DATA で Liquid から注入
   ============================================ */

(function () {
  const data = window.SENCHADO_HERO_DATA || {};
  const PRODUCT_IMAGES = data.product_images || [];
  const IMAGE_ALT = data.image_alt || [];
  const VARIANT_IMAGE_MAP = data.variant_image_map || {};
  const VARIANT_BADGES = data.variant_badges || {};
  const VARIANT_IDS = data.variant_ids || {};
  const STOCK_DATA = data.stock_data || {};
  const PRICES = data.prices || {};
  const PRICES_TTJ = data.prices_ttj || {};
  const PER_CUP = data.per_cup || {};
  // 単品定期プラン: variant.title → { plans: [{ id, name, price, price_amount, compare_at_price }] }
  // allocation を持たない variant は plans:[]（＝その variant では定期不可）。SSOT=spec-purchase-form-subscribe.md
  const PURCHASE_PLANS = data.purchase_plans || {};
  const SHIPPING = data.shipping || {
    cost: 670,
    freeThreshold: 6000,
    cutoffHour: 11,
    cutoffMinute: 30,
    currency: '¥',
  };
  const SHIP_CUTOFF_H = SHIPPING.cutoffHour;
  const SHIP_CUTOFF_M = SHIPPING.cutoffMinute || 0;
  const SYMBOLS = { in: '●', low: '△', out: '✕' };

  function $(id) { return document.getElementById(id); }
  function $$(sel) { return document.querySelectorAll(sel); }

  // 現在メイン画像に表示しているインデックス。 画像を変える全経路（選択変更・サムネ・スワイプ・矢印）が
  // ここを更新し、 バッジも常にこのインデックス基準で出す（バッジ＝表示中の写真のラベル）。
  let currentImageIdx = 0;

  // 長押し拡大（その場拡大）が発動していた指の動きを、画像送りスワイプとして数えないためのガード。
  // 拡大中は指を大きく動かして拡大位置を移動するので、離した瞬間に画像が送られると誤動作に見える。
  let zoomSwipeGuard = false;

  // 画像右上バッジ＝「今表示している写真」のバリアントラベル。 選択中バリアントではなく表示画像に連動させる
  // （専用画像の無いバリアントを選ぶと写真は代表写真のままになるため、 選択連動だと写真とバッジが食い違う）。
  function setBadgeForImage(idx) {
    const badge = $('variantBadge');
    if (!badge) return;
    const vt = IMAGE_ALT[idx];
    if (vt) {
      badge.textContent = VARIANT_BADGES[vt] || vt;
      badge.style.display = '';
    } else {
      // 特定バリアントに紐づかない共通カットはラベル無し。
      badge.style.display = 'none';
    }
  }

  // メイン画像表示の単一窓口。 src・カウンタ・アクティブサムネ・右上バッジ・currentImageIdx を一括更新。
  function showMainImage(idx) {
    const total = PRODUCT_IMAGES.length;
    if (total === 0) return;
    currentImageIdx = ((idx % total) + total) % total; // wrap
    const main = $('mainImg');
    if (main && PRODUCT_IMAGES[currentImageIdx]) main.src = PRODUCT_IMAGES[currentImageIdx];
    const counter = document.querySelector('[data-main-counter]');
    if (counter) counter.textContent = (currentImageIdx + 1) + ' / ' + total;
    $$('.hero__thumb').forEach((t, i) => t.classList.toggle('is-active', i === currentImageIdx));
    setBadgeForImage(currentImageIdx);
  }

  // --- Image switch via thumbnail ---
  window.switchImg = function (thumb, idx) {
    // サムネ・スワイプ・矢印は「画像の閲覧」のみ。 バリアント選択（＝購入対象・価格・¥/杯）は変えない。
    // 画像を動かしたときにバリアントまで変わってしまうのを防ぐ（谷本指定 2026-06-26）。選択はドロップダウンで行う。
    // 右上バッジは showMainImage 内で表示中の写真に追従する（共通カットは自動で非表示）。
    showMainImage(idx);
  };

  // --- Inventory row ---
  function renderInventoryRow() {
    const row = $('inventoryRow');
    if (!row) return;
    const entries = Object.entries(STOCK_DATA);
    if (entries.length === 0) { row.innerHTML = ''; return; }
    row.innerHTML = '在庫：' + entries.map(([v, s]) =>
      `<span class="inventory-item"><span class="inventory-symbol inventory-symbol--${s}">${SYMBOLS[s] || ''}</span>${VARIANT_BADGES[v] || v}</span>`
    ).join('');
  }

  // --- Variant ---
  function updateVariantImage() {
    const sel = $('variantSelect');
    if (!sel) return;
    const idx = VARIANT_IMAGE_MAP[sel.value];
    if (idx !== undefined && PRODUCT_IMAGES[idx]) {
      // 画像・カウンタ・サムネ・バッジを一括同期（バッジは表示画像基準）。
      showMainImage(idx);
    }
    const swatch = $('varSwatchImg');
    if (swatch && idx !== undefined && PRODUCT_IMAGES[idx]) {
      swatch.src = PRODUCT_IMAGES[idx];
    }
  }

  // バリアント切替に追従して メイン価格 / TTJ価格 / ¥/杯 を更新。
  // money は Liquid 側で整形済みの文字列を注入しているため、 JS では再フォーマットしない。
  function updatePrice() {
    const sel = $('variantSelect');
    if (!sel) return;
    const key = sel.value;
    const priceEl = $('heroPriceValue');
    if (priceEl && PRICES[key]) priceEl.textContent = PRICES[key];
    const ttjEl = $('heroPriceTtjValue');
    if (ttjEl && PRICES_TTJ[key]) ttjEl.textContent = PRICES_TTJ[key];
    const percupWrap = $('heroPercup');
    const percupVal = $('heroPercupValue');
    if (percupWrap && percupVal) {
      const pc = PER_CUP[key];
      if (pc) {
        percupVal.textContent = pc;
        percupWrap.hidden = false;
      } else {
        percupWrap.hidden = true;
      }
    }
  }

  // Sold-out variants remain browsable; purchase controls follow availability.
  function syncVariantPurchaseButton() {
    const sel = $('variantSelect');
    const btn = document.querySelector('.btn-cart');
    if (!sel || !btn || btn.classList.contains('early-access-button-locked') ||
        btn.classList.contains('sell-start-locked')) return;
    // 追加中は触らない（途中で在庫ありの種類に替えると早く有効化され二重送信になる）。復帰時に呼び直す。
    if (btn.dataset.busy) return;
    const available = STOCK_DATA[sel.value] !== 'out';
    btn.disabled = !available;
    btn.setAttribute('aria-disabled', String(!available));
    if (!available) btn.textContent = data.sold_out_label || '在庫切れ';
    else updateCartButtonLabel();
  }

  function syncVariantUrl() {
    const sel = $('variantSelect');
    const id = sel && VARIANT_IDS[sel.value];
    if (!id) return;
    const url = new URL(window.location.href);
    url.searchParams.set('variant', String(id));
    window.history.replaceState(window.history.state, '', url.toString());
  }

  function selectVariant(size) {
    const sel = $('variantSelect');
    if (!sel) return;
    sel.value = size;
    updateVariantImage(); // 画像＋バッジ（表示画像連動）＋サムネ＋スウォッチ
    updatePrice();
    // 定期: 選択 variant のプラン一覧を差し替え、現在のモードで価格を再描画。
    // （4g は定期プラン無し等、variant ごとに subscribe 可否が変わるため必須）
    if (document.querySelector('[data-purchase-type]')) {
      populatePlanSelect();
      renderPriceForMode();
    }
    syncVariantPurchaseButton();
    syncVariantUrl();
    syncDynamicCheckout(); // 動的チェックアウトの id/表示を選択 variant に同期（M16）
  }

  // ============================================================
  // 購入形態（単発 / 単品定期）— SSOT=docs/spec-purchase-form-subscribe.md §A
  // 「唯一の真実」は選択中 variant の PURCHASE_PLANS[...].plans。price も plan.price を使い
  // 割引率の独自計算はしない。トグル未描画（プラン無し/先行発売ロック）時は全 no-op。
  // ============================================================
  let purchaseType = 'onetime';   // 'onetime' | 'subscribe'
  let subscribePlanId = null;     // 選択中 selling_plan id（文字列）

  // 定期便でしか買えない商品（Liquid が product.requires_selling_plan を見て印を付ける）。
  // このとき「1回のみのお届け」タブは描画されない → 既定も単発にしてはいけない。
  function isSubscribeOnly() {
    const wrap = document.querySelector('[data-purchase-type]');
    return !!(wrap && wrap.hasAttribute('data-subscribe-only'));
  }

  function currentVariantKey() {
    const sel = $('variantSelect');
    if (sel) return sel.value;
    // 単一バリアント商品は select が描画されない。default variant の title を id から逆引き。
    const did = data.default_variant_id;
    if (did != null) {
      for (const t in VARIANT_IDS) {
        if (String(VARIANT_IDS[t]) === String(did)) return t;
      }
    }
    return null;
  }

  function plansForCurrentVariant() {
    const key = currentVariantKey();
    const entry = key != null ? PURCHASE_PLANS[key] : null;
    return (entry && Array.isArray(entry.plans)) ? entry.plans : [];
  }

  // 単発なら null、定期かつ plan 選択済みならその id。/cart/add.js payload と表示価格の唯一の出所。
  function currentSellingPlanId() {
    return (purchaseType === 'subscribe' && subscribePlanId) ? subscribePlanId : null;
  }

  function planOptionLabel(p) {
    return p.price ? `${p.name} — ${p.price}` : p.name;
  }

  // 選択中 variant の頻度 option を再構築。プラン0件なら subscribe タブを無効化し単発へ強制。
  function populatePlanSelect() {
    const freqSel = document.querySelector('[data-subscribe-plan]');
    const subscribeTab = document.querySelector('.hero__ptype-tab[data-ptype="subscribe"]');
    const plans = plansForCurrentVariant();
    if (freqSel) {
      freqSel.innerHTML = plans
        .map((p) => `<option value="${p.id}">${planOptionLabel(p)}</option>`)
        .join('');
      subscribePlanId = plans.length ? String(plans[0].id) : null;
      if (subscribePlanId) freqSel.value = subscribePlanId;
    }
    if (subscribeTab) {
      if (!plans.length) {
        subscribeTab.disabled = true;
        subscribeTab.setAttribute('aria-disabled', 'true');
        // 定期便でしか買えない商品では「単発へ逃がす」ことができない（単発タブが無いし、
        // 単発でカートに入れても Shopify 側で弾かれる）。その場合は subscribe のまま置く。
        if (purchaseType === 'subscribe' && !isSubscribeOnly()) setPurchaseType('onetime');
      } else {
        subscribeTab.disabled = false;
        subscribeTab.removeAttribute('aria-disabled');
      }
    }
  }

  // CTA ラベル。ロックボタン・在庫切れ disabled は触らない。
  //
  // 「定期便で購入する」は **単発と並んでいるとき** の対比の言葉。
  // 定期便でしか買えない商品（TTJ）では対比する相手がいないので、この書き方は
  // 「定期便」という重い言葉を選択肢でもないのに前に出すだけになり CV を下げる
  // （谷本指摘 2026-08-03「前提として単品があるからこの書き方でしょ。CV下げてるっつの」）。
  // → 定期専用商品では TTJ LP と同じ文言に揃える（sections/senchado-ttj-lp.liquid の
  //    cta_text 既定値。申込導線の頭からお尻まで同じ言葉にする）。
  const SUBSCRIBE_ONLY_CTA = 'お茶の定期便を試してみる';
  function updateCartButtonLabel() {
    const btn = document.querySelector('.btn-cart');
    if (!btn) return;
    if (btn.classList.contains('early-access-button-locked')) return;
    if (btn.disabled) return;
    if (purchaseType !== 'subscribe') { btn.textContent = 'カートに追加する'; return; }
    btn.textContent = isSubscribeOnly() ? SUBSCRIBE_ONLY_CTA : '定期便で購入する';
  }

  // 現モードに合わせて価格表示を切替。定期時は plan.price を主表示し、TTJ価格・¥/杯は隠す
  // （定期便×TTJはスタックしない=決裁① / ¥/杯は単発価格基準のため誤読防止）。
  function renderPriceForMode() {
    const subLabel = $('heroPriceSubLabel');
    const priceEl = $('heroPriceValue');
    const percup = $('heroPercup');
    const ttjRow = document.querySelector('.hero__price-ttj');
    const ttjLink = document.querySelector('.hero__price-ttj-link');
    const planId = currentSellingPlanId();
    if (purchaseType === 'subscribe' && planId) {
      const plan = plansForCurrentVariant().find((p) => String(p.id) === String(planId));
      if (plan && priceEl && plan.price) priceEl.textContent = plan.price;
      if (subLabel) subLabel.hidden = false;
      if (percup) percup.hidden = true;
      if (ttjRow) ttjRow.style.display = 'none';
      if (ttjLink) ttjLink.style.display = 'none';
    } else {
      if (subLabel) subLabel.hidden = true;
      if (ttjRow) ttjRow.style.display = '';
      if (ttjLink) ttjLink.style.display = '';
      updatePrice(); // 単発価格・TTJ・¥/杯 を PRICES/PRICES_TTJ/PER_CUP から復元（percup 可視も再判定）
    }
  }

  function setPurchaseType(type) {
    purchaseType = type;
    document.querySelectorAll('.hero__ptype-tab').forEach((t) => {
      const active = t.getAttribute('data-ptype') === type;
      t.classList.toggle('is-active', active);
      t.setAttribute('aria-checked', active ? 'true' : 'false');
    });
    const freq = document.querySelector('[data-subscribe-freq]');
    if (freq) freq.hidden = (type !== 'subscribe');
    updateCartButtonLabel();
    renderPriceForMode();
    syncDynamicCheckout(); // 定期便選択中は動的チェックアウトを隠す（Buy it now は selling_plan 非対応・M16）
  }

  function initPurchaseType() {
    const wrap = document.querySelector('[data-purchase-type]');
    if (!wrap) return; // トグル未描画 → 定期機構は完全に無効（現行PDPと同一挙動）
    wrap.hidden = false; // JS 到達時のみ表示（JS 無効環境で機能しないトグルを出さない）
    populatePlanSelect();
    wrap.querySelectorAll('.hero__ptype-tab').forEach((t) => {
      t.addEventListener('click', () => {
        if (t.disabled) return;
        setPurchaseType(t.getAttribute('data-ptype'));
      });
    });
    const freqSel = wrap.querySelector('[data-subscribe-plan]');
    if (freqSel) {
      freqSel.addEventListener('change', () => {
        subscribePlanId = freqSel.value || null;
        renderPriceForMode();
      });
    }
    // 単発タブが無い＝定期便でしか買えない商品。既定を subscribe にする。
    setPurchaseType(isSubscribeOnly() ? 'subscribe' : 'onetime');
  }

  // ============================================================
  // 動的チェックアウト（Apple Pay / Shop Pay / Google Pay / PayPal 等・監査 M16）
  // payment_button は native {% form 'product' %} を要するため、hero では .btn-cart(JS fetch)
  // とは別立ての最小フォームに描画している。ここでは (1) 選択中 variant の id を hidden input に同期し、
  // (2) 売り切れ variant / 定期便選択中 / ギフト包装・紙袋 選択中 は非表示にする。
  //   ・Buy it now は selling_plan 非対応のため定期便では出さない。
  //   ・payment_button（加速決済）は .btn-cart の JS フック（senchado-gift-wrap.js の capture ハイジャックで
  //     資材明細を同梱する唯一の経路）を迂回してカートを飛ばす。包装/紙袋が選ばれている間に押させると、
  //     資材が一切乗らないまま決済が完了し「包装なしで出荷」される無言の事故になる（監査 M16×G3a 干渉）。
  //     選択中は payment_button を伏せ、資材を確実に同梱する .btn-cart 経路へ誘導する。
  // フォーム未描画（先行発売ロック / 完全売り切れ）時は全 no-op。
  // 在庫判定は STOCK_DATA を再利用（liquid 側で v.available==false のみ 'out' を出す＝非在庫の唯一値）。
  // ============================================================

  // ギフト包装（風呂敷/箱ラジオ）または お渡し用紙袋（チェックボックス）が選択されているか。
  //   非対象商品・在庫なしでは包装UI（[data-sc-giftwrap-pdp]）が未描画 → false（payment_button は通常表示）。
  //   判定条件は senchado-gift-wrap.js の「.btn-cart 乗っ取りで資材を追加する」条件と一致させる。
  //   ずれると加速決済で資材が漏れる / 過剰に隠れる。
  //   2026-08-12: 「包装しない」カードを廃止したので、未選択＝:checked が無い状態になった。
  //   2026-08-21: 紙袋のトグルを商品単位で復活（gift-bag-offer 登録商品）。紙袋は (大)/(細長) の
  //     **2枚以上**並ぶので querySelectorAll で全部見る。querySelector だと先に描画された1枚しか
  //     見ないため、2枚目を選んだときに加速決済が出たままになり、Shop Pay で決済すると
  //     紙袋が注文から黙って漏れる（谷本さん実機指摘 2026-08-21）。
  function giftWrapEngaged() {
    const box = document.querySelector('[data-sc-giftwrap-pdp]');
    if (!box) return false;
    const choice = box.querySelector('input[name="sc-gw-choice"]:checked');
    // 「包装しない」カードは 2026-08-12 に廃止。未選択＝choice が null。
    const wrapSelected = !!choice;
    const bagOn = Array.prototype.some.call(
      box.querySelectorAll('[data-sc-gw-bag-toggle]'),
      function (bag) {
        return bag.checked && !bag.disabled;
      }
    );
    return wrapSelected || bagOn;
  }

  function syncDynamicCheckout() {
    const form = document.querySelector('[data-hero-dynamic-checkout]');
    if (!form) return;
    const idInput = form.querySelector('[data-hero-dynamic-variant-id]');
    const key = currentVariantKey();
    const vid = (key != null && VARIANT_IDS[key] != null) ? VARIANT_IDS[key] : data.default_variant_id;
    const available = (key != null) ? (STOCK_DATA[key] !== 'out') : true;
    // 単発 かつ 在庫あり かつ 包装/紙袋 未選択 のときだけ加速決済を出す。
    const show = available && purchaseType === 'onetime' && !giftWrapEngaged();
    if (idInput) {
      if (vid != null) idInput.value = String(vid);
      // disabled input は送信されない → 非表示時に古い/売切 variant で誤決済されるのを防ぐ多重防御
      idInput.disabled = !show;
    }
    form.hidden = !show;
  }

  // --- Quantity ---
  window.changeQty = function (delta) {
    const el = $('qtyValue');
    if (!el) return;
    let val = parseInt(el.textContent, 10) + delta;
    if (val < 1) val = 1;
    if (val > 99) val = 99;
    el.textContent = val;
  };

  // --- Flavor tooltip ---
  function positionTooltip(btn) {
    const tip = btn.querySelector('.flavor-tooltip');
    if (!tip) return;
    tip.style.left = '50%';
    btn.style.setProperty('--tt-x', '-50%');
    btn.style.setProperty('--arrow-left', '50%');
    const btnRect = btn.getBoundingClientRect();
    const tipW = tip.offsetWidth;
    const margin = 8;
    const btnCenter = btnRect.left + btnRect.width / 2;
    const tipLeft = btnCenter - tipW / 2;
    const tipRight = btnCenter + tipW / 2;
    let shift = 0;
    if (tipLeft < margin) {
      shift = margin - tipLeft;
    } else if (tipRight > window.innerWidth - margin) {
      shift = (window.innerWidth - margin) - tipRight;
    }
    if (shift !== 0) {
      const pxFromLeft = -tipW / 2 + shift;
      btn.style.setProperty('--tt-x', pxFromLeft + 'px');
      const arrowPos = (tipW / 2 - shift);
      btn.style.setProperty('--arrow-left', arrowPos + 'px');
    }
  }

  let flavorTimer = null;
  window.toggleFlavor = function (btn) {
    const wasActive = btn.classList.contains('is-active');
    $$('.flavor-word').forEach((w) => {
      w.classList.remove('is-active');
      w.classList.remove('is-dismissed');
    });
    clearTimeout(flavorTimer);
    if (!wasActive) {
      positionTooltip(btn);
      btn.classList.add('is-active');
      flavorTimer = setTimeout(() => btn.classList.remove('is-active'), 2500);
    } else {
      btn.classList.add('is-dismissed');
    }
  };

  // --- Shipping ---
  // 計算・地方判定・到着日算出・日付整形は window.SenchadoShipping
  // （assets/senchado-shipping.js）へ委譲。記事ペアリングと同一の共通部品を参照する。
  // この script より前に senchado-shipping.js を defer 読み込みする（hero liquid で担保）。
  function getRegionFromPrefecture(pref) {
    const S = window.SenchadoShipping;
    return S ? S.getRegionFromPrefecture(pref) : '関東';
  }

  function initShippingCountdown() {
    const countdownEl = $('shipCountdown');
    const rowEl = $('shipCountdownRow');
    if (!countdownEl || !rowEl) return;
    const S = window.SenchadoShipping;
    if (!S) return;
    const now = new Date();
    const nowMinutes = now.getHours() * 60 + now.getMinutes();
    const cutoffMinutes = SHIP_CUTOFF_H * 60 + SHIP_CUTOFF_M;
    const r = S.computeCountdown(nowMinutes, cutoffMinutes);
    countdownEl.innerHTML =
      `<span class="shipping-info__delivery-countdown">あと${r.timeStr}</span>以内のご注文で<strong>${r.label}</strong>`;
    rowEl.style.display = 'flex';
  }

  function showArrivalEstimate(pref, region) {
    const S = window.SenchadoShipping;
    if (!S) return;
    const cutoffMinutes = SHIP_CUTOFF_H * 60 + SHIP_CUTOFF_M;
    const arrivalDate = S.computeArrival(new Date(), region, cutoffMinutes);
    const dateStr = S.formatArrival(arrivalDate);
    const unknown = $('deliveryUnknown');
    const known = $('deliveryKnown');
    const text = $('deliveryText');
    const loc = $('deliveryLocation');
    if (unknown) unknown.style.display = 'none';
    if (known) known.style.display = 'flex';
    if (text) text.innerHTML = `${pref}へ最短 <strong>${dateStr}</strong> にお届け`;
    if (loc) loc.textContent = `配送先：${pref}（位置情報から推定）`;
  }

  window.requestLocation = function () {
    const btn = document.querySelector('.shipping-info__locate-btn');
    if (btn) {
      btn.textContent = '取得中...';
      btn.disabled = true;
    }
    if (!navigator.geolocation) {
      showArrivalEstimate('東京都', '関東');
      return;
    }
    // getCurrentPosition の timeout は許可プロンプト保留中はカウントされず「取得中...」のまま
    // 無言になる。2.5秒で東京都基準を先に出し、後から取れたら実際の都道府県で上書き（谷本FB 2026-07-28）
    const provisional = setTimeout(() => showArrivalEstimate('東京都', '関東'), 2500);
    const finish = (pref, region) => {
      clearTimeout(provisional);
      showArrivalEstimate(pref, region);
    };
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const url = `https://nominatim.openstreetmap.org/reverse?lat=${pos.coords.latitude}&lon=${pos.coords.longitude}&format=json&accept-language=ja`;
        // 逆ジオコーダにも5秒タイムアウト（fetch宙吊りで確定しないのを防ぐ）
        const ctrl = new AbortController();
        const abortTimer = setTimeout(() => ctrl.abort(), 5000);
        fetch(url, { signal: ctrl.signal })
          .then((r) => r.json())
          .then((d) => {
            clearTimeout(abortTimer);
            const pref = d.address?.province || d.address?.state || '東京都';
            const region = getRegionFromPrefecture(pref);
            finish(pref, region);
          })
          .catch(() => {
            clearTimeout(abortTimer);
            finish('東京都', '関東');
          });
      },
      () => finish('東京都', '関東'),
      { timeout: 8000 }
    );
  };

  // --- Cart add ---
  // 純関数: /cart/add.js の payload を組む（契約テスト: tests/senchado-cart-add-payload.test.mjs）。
  // selling_plan は「定期便選択時のみ」item に付与。単発時は絶対に付けない＝取り違えて定期化しない
  // （spec-purchase-form-subscribe.md 最重要警告）。sellingPlanId が正の数でなければ無視して単発扱い。
  // drawerPresent=true のときだけ cart-drawer 再描画用の sections を同梱。
  function buildCartAddBody(variantId, quantity, sellingPlanId, drawerPresent, sectionsUrl) {
    const item = { id: Number(variantId), quantity: Number(quantity) };
    const planNum = Number(sellingPlanId);
    if (sellingPlanId != null && sellingPlanId !== '' && Number.isFinite(planNum) && planNum > 0) {
      item.selling_plan = planNum;
    }
    const body = { items: [item] };
    if (drawerPresent) {
      body.sections = 'cart-drawer,cart-icon-bubble';
      body.sections_url = sectionsUrl;
    }
    return body;
  }
  // ブラウザ/Node 双方から純関数を参照できるよう公開（テストは Node から呼ぶ）
  window.SenchadoHero = window.SenchadoHero || {};
  window.SenchadoHero.buildCartAddBody = buildCartAddBody;
  // ギフト包装の追加経路（senchado-gift-wrap.js）も復帰時に在庫を見て状態を戻す。
  window.SenchadoHero.syncPurchaseButton = resyncCartButton;

  async function addToCart(variantId, quantity, sellingPlanId, button) {
    const errorEl = document.querySelector('[data-cart-error]');
    if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
    const original = button.textContent;
    button.disabled = true;
    button.dataset.busy = '1';
    button.textContent = '追加中...';

    // Dawn cart-drawer の中身を新しい HTML で書き換えるため、 sections を含めて取得する。
    // 注意: Shopify Ajax Cart API は sections を string（カンマ区切り）で期待する。
    // array で送ると無視されてレスポンスに sections が含まれず、 drawer が空のままになる。
    const drawer = document.querySelector('cart-drawer');
    const body = buildCartAddBody(variantId, quantity, sellingPlanId, !!drawer, window.location.pathname);

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      if (!res.ok) {
        let msg = 'カートに追加できませんでした。';
        try { const d = await res.json(); msg = d.description || d.message || msg; } catch (_) {}
        throw new Error(msg);
      }
      const data = await res.json();
      button.textContent = 'カートに追加しました';
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));

      // Dawn cart-drawer: 中身を新しい sections HTML で書き換え + open
      if (drawer) {
        try {
          // renderContents は data.sections['cart-drawer'] / ['cart-icon-bubble'] を参照する。
          // どちらか欠けると getSectionInnerHTML(undefined) が落ち、追加成功でも「エラー」表示になる。
          // 必要キーが揃っているときだけ再描画し、欠けていたらカゴを開くだけにフォールバック（3AI議論で指摘）。
          const sec = data && data.sections;
          const hasSections = sec && sec['cart-drawer'] && sec['cart-icon-bubble'];
          if (hasSections && typeof drawer.renderContents === 'function') {
            drawer.renderContents(data);
          } else if (typeof drawer.open === 'function') {
            drawer.open();
          }
        } catch (e) { /* fail silently — error is non-fatal */ }
      }

      // 復帰時は「いま選ばれている種類」の在庫で決める（追加中に売切れの種類へ替えられることがある）。
      setTimeout(() => { restoreCartButton(button, original); }, 2000);
    } catch (err) {
      if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
      restoreCartButton(button, original);
    }
  }

  function restoreCartButton(button, original) {
    delete button.dataset.busy;
    button.disabled = false;
    button.textContent = original;
    resyncCartButton();
  }

  // 復帰後の状態を「いまの種類の在庫」と「いまの購入タイプ（単品/定期便）」から決め直す。
  // 種類セレクタの無い単一バリアント商品では在庫同期が何もしないため、ラベルも明示的に再計算する
  // （追加中に単品⇄定期便を切り替えると、クリック時のラベルのまま残っていた）。
  function resyncCartButton() {
    syncVariantPurchaseButton();
    updateCartButtonLabel();
  }

  // --- Init ---
  document.addEventListener('DOMContentLoaded', () => {
    renderInventoryRow();
    updatePrice();
    initPurchaseType(); // 単発/定期トグル配線（トグル未描画なら no-op）
    syncDynamicCheckout(); // 動的チェックアウト（M16）の初期同期（フォーム未描画なら no-op）
    // ギフト包装/紙袋の選択が変わったら加速決済(payment_button)の表示を再評価（M16×G3a 干渉ガード）。
    //   委譲リスナ: change を document で拾えば包装UIの描画順・再描画に依らず確実に反応する。
    //   包装/紙袋を選ぶと payment_button を伏せ、資材を確実に同梱する .btn-cart 経路へ誘導する。
    document.addEventListener('change', (e) => {
      const t = e.target;
      if (t && t.matches && t.matches('[data-sc-giftwrap-pdp] input[name="sc-gw-choice"], [data-sc-giftwrap-pdp] [data-sc-gw-bag-toggle]')) {
        syncDynamicCheckout();
      }
    });
    const sel = $('variantSelect');
    if (sel) {
      sel.addEventListener('change', () => selectVariant(sel.value));
      // スウォッチ（セレクト横の小画像）は選択中バリアントの画像。
      const vi = VARIANT_IMAGE_MAP[sel.value];
      const swatch = $('varSwatchImg');
      if (swatch && vi !== undefined && PRODUCT_IMAGES[vi]) {
        swatch.src = PRODUCT_IMAGES[vi];
      }
    }
    // メイン画像はサーバ描画(product.featured_image)を維持して動かさない。 そのインデックスで
    // 右上バッジ・カウンタ・アクティブサムネ・currentImageIdx を初期化（バッジ＝表示中画像連動）。
    const initMainIdx = (typeof data.default_image_index === 'number') ? data.default_image_index : 0;
    showMainImage(initMainIdx);
    // Explicit variant links open the corresponding image; plain URLs keep the product cover.
    const linkedVariant = new URL(window.location.href).searchParams.get('variant');
    if (sel && linkedVariant && String(VARIANT_IDS[sel.value]) === linkedVariant) updateVariantImage();
    syncVariantPurchaseButton();
    initShippingCountdown();
    const costEl = $('shippingCostText');
    if (costEl) {
      costEl.innerHTML =
        `送料 全国一律 <strong>${SHIPPING.currency}${SHIPPING.cost.toLocaleString()}</strong>｜<strong>${SHIPPING.currency}${SHIPPING.freeThreshold.toLocaleString()}以上</strong>で送料無料`;
    }

    // Flavor tooltip: hover で位置調整、外クリックで閉じる
    $$('.flavor-word').forEach((btn) => {
      btn.addEventListener('mouseenter', () => positionTooltip(btn));
    });
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.flavor-word')) {
        $$('.flavor-word').forEach((w) => {
          w.classList.remove('is-active');
          w.classList.remove('is-dismissed');
        });
      }
    });

    const cartBtn = document.querySelector('.btn-cart');
    if (cartBtn) {
      cartBtn.addEventListener('click', () => {
        // 先行発売ロック（監査横断・collection.js:497 と同方針）: tea_blocked 時の .btn-cart は
        // disabled のロックボタン。Cart Function無効のため、disabled が外されても必ずここで止める。
        if (cartBtn.classList.contains('early-access-button-locked')) return;
        // 予約販売ロック（監査 A-11 / M4・2026-08-04）: sell_info.sell_start_date が未来の間は
        // 在庫があっても購入させない。上と同じく disabled を外されても JS 側で止める。
        if (cartBtn.classList.contains('sell-start-locked')) return;
        const sel2 = $('variantSelect');
        // 個数セレクター撤去後は常に 1 を追加。個数調整はカートドロワー側で。
        const qty = 1;
        if (cartBtn.disabled || (sel2 && STOCK_DATA[sel2.value] === 'out')) return;
        const variantSize = sel2 ? sel2.value : null;
        const vid = variantSize && VARIANT_IDS[variantSize] ? VARIANT_IDS[variantSize] : (data.default_variant_id || null);
        if (!vid) return;
        // 定期便選択時のみ selling_plan を送出（単発は null＝現行と同一 payload）。
        addToCart(vid, qty, currentSellingPlanId(), cartBtn);
      });
    }


    // ----------------------------------------------------------------------
    // メイン画像のスワイプ / 矢印ナビ / カウンタ（Qoo10 風）
    // PC では矢印・カウンタを CSS で隠し、 サムネクリックで切替 (既存挙動)。
    // スマホではサムネを非表示にして、 メイン画像のスワイプ・矢印・カウンタを主導線にする。
    // ----------------------------------------------------------------------
    const mainImage = document.querySelector('[data-main-image]');
    const mainImg = $('mainImg');
    const mainPrev = document.querySelector('[data-main-prev]');
    const mainNext = document.querySelector('[data-main-next]');
    const mainCounter = document.querySelector('[data-main-counter]');

    if (mainImage && mainImg && PRODUCT_IMAGES.length) {
      const total = PRODUCT_IMAGES.length;

      // 隣接画像をブラウザキャッシュに先読み（切替遅延を消す）
      const preloaded = new Set();
      function preloadAt(idx) {
        if (total === 0) return;
        const i = ((idx % total) + total) % total;
        if (preloaded.has(i)) return;
        const img = new Image();
        img.src = PRODUCT_IMAGES[i];
        preloaded.add(i);
      }

      // 表示は showMainImage（src・カウンタ・サムネ・バッジ・currentImageIdx を一括更新）へ委譲し、
      // ここでは前後の先読みだけ足す。 起点は常に currentImageIdx（選択変更・サムネ後も追従）。
      function nav(idx) {
        showMainImage(idx);
        preloadAt(currentImageIdx + 1);
        preloadAt(currentImageIdx + 2);
        preloadAt(currentImageIdx - 1);
      }

      // 初期表示時にも前後を先読み
      preloadAt(currentImageIdx + 1);
      preloadAt(currentImageIdx - 1);

      mainPrev && mainPrev.addEventListener('click', () => nav(currentImageIdx - 1));
      mainNext && mainNext.addEventListener('click', () => nav(currentImageIdx + 1));

      // タッチスワイプ
      let touchStartX = 0;
      let touchStartY = 0;
      mainImage.addEventListener('touchstart', (e) => {
        const t = e.touches[0];
        touchStartX = t.clientX;
        touchStartY = t.clientY;
        zoomSwipeGuard = false;
      }, { passive: true });
      mainImage.addEventListener('touchend', (e) => {
        // 長押し拡大していた指の動きは画像送りに使わない（拡大位置の移動であってスワイプではない）。
        if (zoomSwipeGuard) {
          zoomSwipeGuard = false;
          return;
        }
        const t = e.changedTouches[0];
        const dx = t.clientX - touchStartX;
        const dy = t.clientY - touchStartY;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return; // 水平スワイプのみ
        nav(currentImageIdx + (dx < 0 ? 1 : -1));
      }, { passive: true });

      // 1枚しかない場合は矢印・カウンタを隠す
      if (total <= 1) {
        if (mainPrev) mainPrev.hidden = true;
        if (mainNext) mainNext.hidden = true;
        if (mainCounter) mainCounter.hidden = true;
      }

      // 既存の switchImg (サムネクリック) と同期するため、 グローバルからも呼べるように
      window._heroShowImage = nav;
    }

    // ----------------------------------------------------------------------
    // 画像の「その場拡大」（全画面ポップアップは 2026-07-27 に廃止）。
    // PC: メイン画像にマウスを乗せている間だけ、カーソルの位置を中心に約2倍へ拡大。
    //     マウスが離れたら即座に等倍へ戻る。クリックしても何も起きない。
    // SP: 約250ms の長押しで拡大が発動。発動前に10px以上動いた場合は通常のスクロール
    //     （および横スワイプでの画像送り）として扱い、拡大は発動させない。
    //     発動中は拡大の中心が指に追従し、ページはスクロールしない。指を離したら即等倍。
    // 重ねた <img class="hero__zoom-layer"> の transform だけを動かす（レイアウトは触らない）ので、
    // 画像送り・バリアント連動の既存ロジックには一切影響しない。
    // ----------------------------------------------------------------------
    const zoomLayer = $('heroZoomLayer');
    if (mainImage && mainImg && zoomLayer && PRODUCT_IMAGES.length) {
      // 2倍表示でも粗くならないよう、拡大レイヤーだけ高解像度（1600w）を使う。
      const ZOOM_IMAGES = (data.product_images_zoom && data.product_images_zoom.length)
        ? data.product_images_zoom
        : PRODUCT_IMAGES;
      const SCALE = 2;
      const HOLD_MS = 250; // 長押し発動までの待ち時間（スクロールと衝突させないため）
      const MOVE_TOL = 10; // 発動前にこれ以上動いたらスクロール/スワイプ扱い

      const hiresReady = new Set(); // 高解像度を読み終えたインデックス
      let zoomActive = false;
      let holdTimer = null;
      let layerIdx = -1;
      let holdX = 0;
      let holdY = 0;
      let lastTouchAt = 0; // タッチ直後に飛んでくる擬似マウスイベントを無視するため

      // 拡大レイヤーの画像を表示中のものへ同期。まず表示済み（＝キャッシュ済み）の通常解像度を入れて
      // 一瞬も空白を出さず、高解像度は読み終えてから差し替える。
      function syncLayer(idx) {
        if (layerIdx === idx) return;
        const src = (hiresReady.has(idx) ? ZOOM_IMAGES[idx] : null) || PRODUCT_IMAGES[idx];
        if (!src) return;
        layerIdx = idx;
        zoomLayer.src = src;
      }
      function preloadHires(idx) {
        if (hiresReady.has(idx)) return;
        const url = ZOOM_IMAGES[idx];
        if (!url || url === PRODUCT_IMAGES[idx]) return;
        const pre = new Image();
        pre.onload = function () {
          hiresReady.add(idx);
          if (layerIdx === idx) zoomLayer.src = url;
        };
        pre.src = url;
      }

      // 拡大の中心＝指/カーソルの位置。その点の下にあるものが動かないので
      // 「触ったところが拡大される」感覚になる。
      function setOrigin(clientX, clientY) {
        const r = mainImage.getBoundingClientRect();
        if (!r.width || !r.height) return;
        const x = Math.min(Math.max(clientX - r.left, 0), r.width);
        const y = Math.min(Math.max(clientY - r.top, 0), r.height);
        zoomLayer.style.transformOrigin = ((x / r.width) * 100) + '% ' + ((y / r.height) * 100) + '%';
      }

      function zoomIn(clientX, clientY) {
        syncLayer(currentImageIdx);
        preloadHires(currentImageIdx);
        setOrigin(clientX, clientY);
        zoomActive = true;
        zoomLayer.style.transform = 'scale(' + SCALE + ')';
        mainImage.classList.add('is-zooming');
      }
      function zoomOut() {
        if (holdTimer) {
          clearTimeout(holdTimer);
          holdTimer = null;
        }
        if (!zoomActive) return;
        zoomActive = false;
        zoomLayer.style.transform = '';
        mainImage.classList.remove('is-zooming');
      }

      // 初期化時に拡大レイヤーへ現在の画像を入れておく（メイン画像と同じURL＝キャッシュ済みなので
      // 追加の通信は発生しない）。最初の拡大でも一瞬の空白を出さないための地ならし。
      syncLayer(currentImageIdx);

      // --- PC: マウスオーバー中だけ拡大 -------------------------------------
      // タッチ端末で発生する擬似マウスイベントで誤発動しないよう、毎回 hover 可否を見る。
      const hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
      mainImage.addEventListener('mouseenter', (e) => {
        if (!hoverQuery.matches) return;
        if (Date.now() - lastTouchAt < 700) return; // 直前が指の操作なら長押し側に任せる
        zoomIn(e.clientX, e.clientY);
      });
      mainImage.addEventListener('mousemove', (e) => {
        if (!zoomActive) return;
        syncLayer(currentImageIdx); // 拡大中に矢印/サムネで画像が変わった場合も追従
        setOrigin(e.clientX, e.clientY);
      });
      mainImage.addEventListener('mouseleave', zoomOut);

      // --- SP: 長押ししている間だけ拡大 -------------------------------------
      mainImage.addEventListener('touchstart', (e) => {
        lastTouchAt = Date.now();
        if (e.touches.length !== 1) return; // ピンチ等はブラウザ標準に任せる
        // 画像送り矢印の長押しでは拡大しない（ボタンはボタンとして押せるままにする）
        if (e.target && e.target.closest && e.target.closest('button')) return;
        const t = e.touches[0];
        holdX = t.clientX;
        holdY = t.clientY;
        if (holdTimer) clearTimeout(holdTimer);
        holdTimer = setTimeout(() => {
          holdTimer = null;
          zoomSwipeGuard = true; // この指の動きは画像送りとして数えない
          zoomIn(holdX, holdY);
        }, HOLD_MS);
      }, { passive: true });

      mainImage.addEventListener('touchmove', (e) => {
        const t = e.touches[0];
        if (!t) return;
        if (zoomActive) {
          // 拡大中はページを動かさず、拡大の中心だけ指に追従させる
          if (e.cancelable) e.preventDefault();
          setOrigin(t.clientX, t.clientY);
          return;
        }
        if (holdTimer && (Math.abs(t.clientX - holdX) > MOVE_TOL || Math.abs(t.clientY - holdY) > MOVE_TOL)) {
          // 発動前に指が動いた＝スクロール、または横スワイプでの画像送り。拡大は発動させない。
          clearTimeout(holdTimer);
          holdTimer = null;
        }
      }, { passive: false });

      mainImage.addEventListener('touchend', zoomOut, { passive: true });
      mainImage.addEventListener('touchcancel', zoomOut, { passive: true });

      // 長押し中に画像の保存メニューが出ると拡大が中断されるので抑止（CSS 側でも callout を切っている）。
      mainImage.addEventListener('contextmenu', (e) => {
        if (zoomActive) e.preventDefault();
      });

      // 画面幅が変わると拡大の中心がずれるため、いったん等倍へ戻す。
      window.addEventListener('resize', zoomOut);
    }

    // ----------------------------------------------------------------------
    // Mobile thumbnail slider: prev/next arrow buttons.
    // PC は grid 縦並びで矢印は CSS 側で常に hidden。
    // スマホでは strip が overflow したときだけ矢印を表示してスクロール可能であることを伝える。
    // ----------------------------------------------------------------------
    const thumbStrip = document.querySelector('[data-thumb-strip]');
    const thumbPrev = document.querySelector('[data-thumb-prev]');
    const thumbNext = document.querySelector('[data-thumb-next]');

    if (thumbStrip && thumbPrev && thumbNext) {
      const SCROLL_STEP = 200;

      const updateArrowVisibility = () => {
        const max = thumbStrip.scrollWidth - thumbStrip.clientWidth;
        if (max <= 1) {
          thumbPrev.hidden = true;
          thumbNext.hidden = true;
          return;
        }
        thumbPrev.hidden = thumbStrip.scrollLeft <= 1;
        thumbNext.hidden = thumbStrip.scrollLeft >= max - 1;
      };

      thumbPrev.addEventListener('click', () => {
        thumbStrip.scrollBy({ left: -SCROLL_STEP, behavior: 'smooth' });
      });
      thumbNext.addEventListener('click', () => {
        thumbStrip.scrollBy({ left: SCROLL_STEP, behavior: 'smooth' });
      });
      thumbStrip.addEventListener('scroll', updateArrowVisibility, { passive: true });
      window.addEventListener('resize', updateArrowVisibility);
      window.requestAnimationFrame(updateArrowVisibility);
      window.setTimeout(updateArrowVisibility, 500);
    }
  });

  // ----------------------------------------------------------------------
  // Judge.me review badge: バリエーションセレクター直前に置いた hero-review を、
  // レビュー件数 0 のときだけ完全に隠す（Qoo10風: レビューがあるときのみ表示）。
  // 本番テーマ (Maps Banner Test) では Judge.me が実レビューを描画し、 件数>0 のときのみ表示。
  // dev store (greenbrewing.myshopify.com) では Judge.me が動かないため hero-review は
  // skeleton のまま最終的に非表示になる（仮のレビューは差し込まない）。
  //
  // 注意: DOMContentLoaded リスナーは defer + 他 script の遅延で間に合わないケース
  // があるため、 readyState で即時 / 待機 を切り替える。
  // ----------------------------------------------------------------------
  function initHeroReview() {
    const heroReview = document.querySelector('[data-hero-review]');
    if (!heroReview) return;
    // 初期描画は skeleton 表示で領域確保済み。 データ取得後に内容を差し替える。
    heroReview.classList.add('is-skeleton');

    const checkReviewCount = () => {
      const badge = heroReview.querySelector('.jdgm-prev-badge');
      if (!badge) return false;
      const raw = badge.getAttribute('data-number-of-reviews');
      if (raw === null) return false;
      const count = parseInt(raw, 10);
      if (Number.isFinite(count) && count > 0) {
        heroReview.hidden = false;
      }
      return true;
    };
    [200, 600, 1500, 3000].forEach((delay) => window.setTimeout(checkReviewCount, delay));

    let rotationTimer = null;

    // 商品の総合評価（平均星）+ 件数 + ★5 評価レビュー本文を表示。
    // bodies が複数あれば自動スライド (5秒間隔)。
    function renderReviewSummary(num, avg, bodies) {
      const pct = Math.min(100, Math.max(0, (avg / 5) * 100));
      const avgText = Number.isFinite(avg) ? avg.toFixed(1) : '0.0';
      const firstBody = bodies && bodies.length ? bodies[0] : '';
      heroReview.innerHTML =
        '<div class="hero-review__summary">' +
          '<span class="hero-review__stars" style="--rating-pct: ' + pct + '%" aria-label="平均 ' + avgText + ' / 5">★★★★★</span>' +
          '<span class="hero-review__rating-num">' + avgText + '</span>' +
          '<span class="hero-review__count">(' + num + '件)</span>' +
        '</div>' +
        (firstBody ? '<span class="hero-review__pick-body">「' + firstBody + '」</span>' : '');
      heroReview.hidden = false;
      heroReview.classList.remove('is-skeleton');

      // 複数件あれば 5秒ごとフェード切替
      if (rotationTimer) { clearInterval(rotationTimer); rotationTimer = null; }
      if (bodies && bodies.length > 1) {
        let idx = 0;
        const bodyEl = heroReview.querySelector('.hero-review__pick-body');
        if (!bodyEl) return;
        rotationTimer = window.setInterval(() => {
          bodyEl.classList.add('is-fading');
          window.setTimeout(() => {
            idx = (idx + 1) % bodies.length;
            bodyEl.textContent = '「' + bodies[idx] + '」';
            bodyEl.classList.remove('is-fading');
          }, 400);
        }, 5000);
      }
    }

    // 実 Judge.me が描画された場合: 平均+件数を badge から、 ★5 本文一覧を widget から
    function renderFromRealReviews() {
      const badge = heroReview.querySelector('.jdgm-prev-badge');
      if (!badge) return false;
      const num = parseInt(badge.getAttribute('data-number-of-reviews') || '0', 10);
      const avg = parseFloat(badge.getAttribute('data-average-rating') || '0');
      if (!num || num <= 0) return false;

      const fiveStarBodies = [];
      document.querySelectorAll('.jdgm-rev-widg .jdgm-rev').forEach((r) => {
        if (parseInt(r.getAttribute('data-rating') || '0', 10) === 5) {
          const body = r.querySelector('.jdgm-rev__body')?.textContent?.trim();
          if (body) fiveStarBodies.push(body);
        }
      });
      // ★5が無ければ最初のレビュー本文だけ
      if (!fiveStarBodies.length) {
        const first = document.querySelector('.jdgm-rev-widg .jdgm-rev .jdgm-rev__body')?.textContent?.trim();
        if (first) fiveStarBodies.push(first);
      }
      renderReviewSummary(num, avg, fiveStarBodies);
      return true;
    }
    [600, 1500, 3000].forEach((d) => window.setTimeout(renderFromRealReviews, d));

    // 3.5秒経って何も入らなかった (skeleton のまま) なら、 本当にレビュー 0件として hero-review を消す。
    window.setTimeout(() => {
      if (heroReview.classList.contains('is-skeleton')) {
        heroReview.hidden = true;
      }
    }, 3500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeroReview);
  } else {
    initHeroReview();
  }
})();
